// Geotab DashCam Domain Configuration
export const geotabDashcamConfig = {
  // Basic domain information
  id: 'geotab-dashcam',
  name: 'Geotab Dash Cam',
  tagline: 'Professional Dash Cam',
  description: 'Capture every moment with precision and confidence. Engineered for performance, reliability, and ease of use — built for professionals who drive every day.',
  
  // Assets
  logo: '/assets/logos/geotab-dashcam-logo.png',
  whiteLogo: '/assets/logos/geotab-dashcam-white-logo.png',
  favicon: '/assets/favicons/geotab-dashcam-favicon.png',
  icon: '/assets/icons/geotab-dashcam',
  
  // Navigation
  pages: ['home', 'solutions', 'blog'],
  navigation: [
    { name: 'Home', path: '/' },
    { name: 'Solutions', path: '/solutions' },
    { name: 'Blog', path: '/blog' },
  ],
  
  // CTAs
  cta: {
    primary: 'Request Demo',
    secondary: 'Buy now'
  },
      
  // Shop link
  shopLink: 'https://shop.fleethoster.com/collections/geotab',

  // UI Configuration
  variant: 'grid',
  showFeatures: false,
  showTestimonials: false,
  
  // Content sections
  hero: {
    title: 'Geotab Dash Cam',
    subtitle: 'Dash cam solution for professional drivers.',
    features: ['Professional Quality', 'Reliable Recording', 'Easy Management', 'AI Powered']
  },
  
  // Gallery/Image Slider configuration
  gallery: {
    title: 'Geotab Dash Cam Gallery',
    subtitle: 'Explore our professional dash cameras and fleet safety solutions',
    description: 'See how Geotab Dash Cam transforms fleet safety with professional video technology'
  },

  features: {
    title: 'Advanced Dash Cam Features',
    subtitle: 'Comprehensive Solution',
    description: 'Discover the powerful features that make our AI powered dash cams and solutions the best choice for your fleet management needs.',
    items: [
      {
        title: 'Real-time Monitoring',
        description: 'Monitor your fleet in real-time with comprehensive tracking and reporting capabilities.',
        icon: '📊'
      },
      {
        title: 'Advanced Analytics',
        description: 'Get insights with advanced analytics and reporting tools for better decision making.',
        icon: '📈'
      },
      {
        title: 'Easy Integration',
        description: 'Seamless integration with existing systems and third-party applications.',
        icon: '🔗'
      },
      {
        title: '24/7 Support',
        description: 'Round-the-clock support with dedicated customer service and technical assistance.',
        icon: '🆘'
      }
    ]
  },
  
  solutions: {
    title: 'Geotab Dash Cam Solutions',
    subtitle: 'Designed for Professional Drivers and Fleets',
    description: 'Experience unmatched reliability, crystal-clear recording, and seamless operation — the ultimate dash cam for professionals on the road.',
    sections: [
      {
        title: 'Critical events + video coaching in one',
        description: 'GO Focus Plus AI dash cam cuts wasted hours from review. High-risk actions, like fatigue, tailgating and hard braking, trigger instant in-cab voice alerts for drivers, helping build better habits in real time. For managers, the most critical events are surfaced first with video and context, making it easy to review urgent risks and coach effectively in one streamlined workflow. The system analyzes events right in the vehicle delivering faster alerts, keeping data secure and improving automatically with every use.'
      },
      {
        title: 'How GO Focus Plus cuts distracted driving risk',
        description: 'GO Focus Plus addresses distracted driving and other critical risks at every turn. Here\'s how each event moves from detection to improvement, to help your fleet prevent incidents before they happen. On-device computer vision detects risky driving behavior, like distracted driving, tailgating and hard braking. Events are analyzed on the device as they occur. An in-cab voice alert is instantly delivered to the driver. Drivers self-correct in real time, reducing risk before an incident takes place. High-severity or repeated risky events are automatically flagged to the fleet safety manager. Managers review video and event details, then assign targeted feedback or coaching through the built-in driver coaching workflow. Drivers review feedback and recommended actions in the mobile app, then apply safer driving practices on future trips.'
      },
      {
        title: 'Coaching workflow that makes every alert count',
        description: 'With GO Focus Plus, a critical event becomes a driver coaching opportunity inside MyGeotab. Managers see video context, risk level, and recommended next steps—all at a glance. Assign feedback, track driver progress, and recognize improvement with a workflow built for fleet realities. Severity-based dashboards surface the drivers and behaviors that need attention most, so managers act faster and close the loop on risk. Results stay visible, and safer driving habits take hold fleet-wide.'
      }
    ]
  },
  
  
  testimonials: [
    {
      content: "I don't know how we'd do it without Geotab – the solution is literally in every aspect of our operations.",
      author: "Jonathan Hamilton",
      role: "Director of Fleet Safety and Compliance",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/25.jpg"
    },
    {
      content: "We're excited about what's coming next. It just keeps getting better and better, working with their technology and continuing to evolve. It's been great.",
      author: "Christian Reisch",
      role: "Co-owner",
      company: "",
      avatar: "https://randomuser.me/api/portraits/men/20.jpg"
    }
  ],

  blog: {
    title: 'Geotab Dash Cam Blog',
    subtitle: 'Latest trends and insights in fleet management technology',
    description: 'Stay informed with the latest developments in fleet management, technology, and industry best practices.',
  },
  
  // SEO and Meta
  seo: {
    // Basic Meta Tags
    title: 'Geotab Dash Cam - Professional Dash Cam Solutions',
    description: 'Fleet dash cam solution with reliable, high-quality, and user-friendly cameras, offering advanced safety features and fleet protection',
    keywords: [
      'Geotab dash cam', 'professional dash cam', 'driver safety', 'fleet cameras', 'vehicle cameras',
      'dash camera solutions', 'fleet safety cameras', 'professional dash cameras', 'driver protection', 'fleet safety',
      'Geotab dash camera', 'fleet dash cam systems', 'vehicle safety cameras', 'driver monitoring',
      'fleet camera solutions', 'dash cam technology', 'fleet safety systems', 'professional camera systems', 'Geotab'
    ],
    
    // Open Graph & Social Media
    ogTitle: 'Geotab Dash Cam - Professional Dash Cam Solutions',
    ogDescription: 'Single dash cam solution for professional drivers. Reliable, high-quality, and easy to use.',
    ogType: 'website',
    ogUrl: 'https://www.geotabdashcam.com',
    
    // Twitter Cards
    twitterCard: 'summary_large_image',
    twitterTitle: 'Geotab Dash Cam - Professional Dash Cam Solutions',
    twitterDescription: 'Single dash cam solution for professional drivers. Reliable, high-quality, and easy to use.',
    
    // Robots
    robots: 'index, follow',
    author: 'Geotab Dash Cam',
    publisher: 'Geotab Dash Cam',
    
    // Page-Specific SEO
    pages: {
      home: {
        title: 'Geotab Dash Cam - Professional Dash Cam Solutions',
        description: 'Professional single dash cam solution for fleet drivers. Reliable, high-quality, and easy-to-use dash camera technology.',
        keywords: ['Geotab dash cam', 'professional dash cam', 'driver safety', 'fleet cameras', 'vehicle cameras']
      },
      solutions: {
        title: 'Geotab Dash Cam Solutions - Professional Fleet Safety Services',
        description: 'Comprehensive dash cam solutions and fleet safety services. Professional camera installation and driver safety monitoring.',
        keywords: ['dash cam solutions', 'fleet safety services', 'camera installation', 'driver safety monitoring']
      },
      products: {
        title: 'Geotab Dash Cam Products - Professional Dash Camera Equipment',
        description: 'Professional dash cam products and camera equipment. High-quality dash cameras and fleet safety technology.',
        keywords: ['dash cam products', 'camera equipment', 'professional cameras', 'fleet safety technology']
      },
      blog: {
        title: 'Geotab Dash Cam News & Insights - Fleet Safety Blog',
        description: 'Latest news, insights, and best practices for dash cam technology and fleet safety. Professional tips and safety updates.',
        keywords: ['dash cam news', 'fleet safety insights', 'camera technology tips', 'driver safety best practices']
      }
    },
    
    // Performance & Technical SEO
    technical: {
      pageLoadTime: '< 1 second',
      mobileOptimized: true,
      sslEnabled: true,
      schemaMarkup: true,
      xmlSitemap: true,
      robotsTxt: true,
      compressionEnabled: true,
      imageOptimization: true,
      cdnEnabled: true
    },

    // Local Business Info for Structured Data
    localBusiness: {
      streetAddress: '',
      addressLocality: 'Atlanta',
      addressRegion: 'GA',
      postalCode: '30308',
      addressCountry: 'US'
    }
  }
};
